import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'datetimeformat',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class DateTimeFormatPipe implements PipeTransform {
  private translateService = inject(TranslateService);


  private readonly datePatterns = new Map<string, string>([
    ['short', 'd/M/y, h:mm:ss a'],
    ['medium', 'MMM d, y, h:mm:ss a'],
    ['long', 'EEEE, LLLL d, y, h:mm:ss a'],
    ['dateOnly', 'MMM d, y'],
    ['full','EEEE, MMMM d, y, h:mm:ss a zzzz'],
    ['shortDate','M/d/yy'],
    ['mediumDate','MMM d, y'],
    ['longDate','MMMM d, y'],
    ['fullDate','EEEE, MMMM d, y'],
    ['shortTime','h:mm a'],
    ['mediumTime','h:mm:ss a'],
    ['longTime','h:mm:ss a z'],
    ['fullTime','h:mm:ss a zzzz'],
    ['atDate','dd MMM yyyy,hh:mm a'],
    ['usformat','M/d/yyyy'],
    ['ukformat','dd MMM yyyy'],
    ['expiryDate','M/d'],
    ['date','d'],
    ['month','M'],
    ['year','yyyy'],
    ['month-year','MMM yyyy'],
    ['datetime','d MMM yy hh:mm:ss a'],
    ['defaultformat','d MMM yy'],
    ['dateOnly_1', 'MMM d, yy'],
    ['dayname','EE']
  ]);


  transform(date: Date | string, format?: string, applyTimezone= true): any {
    //const localDate= this.timeService.ConvertUTCToLocalDateTime(date);
    let pattern=this.datePatterns.get('dateOnly');
    if (format) pattern = this.datePatterns.get(format!) ?? format;
    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);
    return datePipe.transform(applyTimezone ? ConvertUTCToLocalDateTime(date) : date, pattern);
  }

}


export const dateCollection = [
  {
    name: "Tomorrow", value: "tomorrow", date: (): Date => {
      return new Date((new Date()).setDate((new Date()).getDate() + 1));
    }
  },
  {
    name: "Yesterday", value: "yesterday", date: (): Date => {
      return new Date((new Date()).setDate((new Date()).getDate() - 1));
    }
  },
  {
    name: "In 2 days", value: "in 2 buisness days", date: (): Date => {
      return new Date((new Date()).setDate((new Date()).getDate() + 2));
    }
  },
  {
    name: "In 3 days", value: "in 3 buisness days", date: (): Date => {
      return new Date((new Date()).setDate((new Date()).getDate() + 3));
    }
  },
  {
    name: "this week", value: "this week", date: (): Date => {
      return new Date((new Date()).setDate((new Date()).getDate() + 2));
    }
  },
  {
    name: "In 1 Week", value: "in 1 week", date: (): Date => {
      return new Date((new Date()).getTime() + 7 * 24 * 60 * 60 * 1000);
    }
  },
  {
    name: "In 2 Weeks", value: "in 2 week", date: (): Date => {
      return new Date((new Date()).getTime() + 14 * 24 * 60 * 60 * 1000);
    }
  },
  {
    name: "In 1 Month", value: "in 1 month", date: (): Date => {
      const now = new Date();
      const lastDateOfNewDate: number = new Date(now.getFullYear(), now.getMonth() + 2, 0).getDate();
      const date = (now.getDate() >= lastDateOfNewDate ? lastDateOfNewDate : now.getDate()) - 1;
      return new Date(now.getFullYear(), now.getMonth() + 1, date);
    }
  },
  {
    name: "In 2 Months", value: "in 2 months", date: (): Date => {
      const now = new Date();
      const lastDateOfNewDate: number = new Date(now.getFullYear(), now.getMonth() + 3, 0).getDate();
      const date = (now.getDate() >= lastDateOfNewDate ? lastDateOfNewDate : now.getDate()) - 1;
      return new Date(now.getFullYear(), now.getMonth() + 2, date);
    }
  },
  {
    name: "In 6 Months", value: "in 6 months", date: (): Date => {
      const now = new Date();
      const lastDateOfNewDate: number = new Date(now.getFullYear(), now.getMonth() + 7, 0).getDate();
      const date = (now.getDate() >= lastDateOfNewDate ? lastDateOfNewDate : now.getDate()) - 1;
      return new Date(now.getFullYear(), now.getMonth() + 6, date);
    }
  },
  {
    name: "Last 6 Months", value: "last 6 months", date: (): Date => {
      const now = new Date();
      const lastDateOfNewDate: number = new Date(now.getFullYear(), now.getMonth() - 7, 0).getDate();
      const date = (now.getDate() >= lastDateOfNewDate ? lastDateOfNewDate : now.getDate()) - 1;
      return new Date(now.getFullYear(), now.getMonth() - 6, date);
    }
  },
  {
    name: "Custom Date", value: "custom date", date: (): Date => {
      return new Date()
    }
  }
];

export function weekData(type: string){
  const date = new Date();
  const dayOfWeekNumber = date.getDay();
  let nameOfDay;
  let quote;

  switch(dayOfWeekNumber){
      case 0:
          nameOfDay = 'Sunday';
          quote = 'Time to chillax!';
          break;
      case 1:
          nameOfDay = 'Monday';
          quote = 'Monday morning blues!';
          break;
      case 2:
          nameOfDay = 'Tuesday';
          quote = 'Taco Time!';
          break;
      case 3:
          nameOfDay = 'Wednesday';
          quote = 'Two more days to the weekend.';
          break;
      case 4:
          nameOfDay = 'Thursday';
          quote = 'The weekend is almost here...';
          break;
      case 5:
          nameOfDay = 'Friday';
          quote = 'Weekend is here!';
          break;
      case 6:
          nameOfDay = 'Saturday';
          quote = 'Time to party!';
          break;

  }

 const curr = new Date; // get current date

const [firstDayWeek,lastDayWeek]= startAndEndOfWeek(curr);
const [nextWeekFirstDate,nextWeekLastDate] = startAndEndOfNextWeek(curr);

  if(type == 'start'){
    return firstDayWeek;
  } else if(type == 'end'){
    return lastDayWeek;
  } else if(type == 'nextweekstart'){
    return nextWeekFirstDate
  } else if(type == 'nextweekend'){
    return nextWeekLastDate
  } else {
    return null
  }
}


const startAndEndOfWeek = (date:Date) => {
  const now = date ? new Date(date) : new Date().setHours(0, 0, 0, 0);
  const monday = new Date(now);
  monday.setDate(monday.getDate() - monday.getDay());
  const sunday = new Date(now);
  sunday.setDate(sunday.getDate() - sunday.getDay() + 7);
  return [monday, sunday];
}

const startAndEndOfNextWeek = (date:Date) => {
  const now = date ? new Date(date) : new Date().setHours(0, 0, 0, 0);
  const monday = new Date(now);
  monday.setDate(monday.getDate() - monday.getDay() + 7);
  const sunday = new Date(now);
  sunday.setDate(sunday.getDate() - sunday.getDay() + 14);
  return [monday, sunday];
}


 // Convert UTC time to Local Time
  function ConvertUTCToLocalDateTime(date: Date | string): Date {
  const localDate = new Date(date);
  const offset = new Date().getTimezoneOffset();
  localDate.setMinutes(localDate.getMinutes() - offset);
  return localDate;
}
